import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import CustomRadioBtn from "../../base/CustomRadioBtn";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { CustomSquareCheckBox } from "../../base/CustomCheckBox";
import CustomText from "components/base/CustomText";

interface ArgsType {
    vmNetworkId: string;
    domainId: string;
    projectId: string;
}

interface VmSubnetAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

VmSubnetAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function VmSubnetAdd(props:VmSubnetAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    
    const [vmSubnetName, setVmSubnetName] = useState("");
    const [vmSubnetDesc, setVmSubnetDesc] = useState("");
    const [allocatePools, setAllocatePools] = useState("");
    const [dnsNameServers, setDnsNameServers] = useState("");
    const [hostRoutes, setHostRoutes] = useState("");
    const [cidr, setCidr] = useState("");
    const [gatewayIpAddress, setGatewayIpAddress] = useState("");
    const [gatewayYn, setGatewayYn] = useState(true);
    const [dhcpYn, setDhcpYn] = useState(true);
    const [ipVersion, setIpVersion] = useState(4);

    const [vmNetworkId, setVmNetworkId] = useState(props.args?.vmNetworkId);
    const [vmSubnetNameWarnYn, setVmSubnetNameWarnYn] = useState(false);
    const [vmCidrWarnYn, setCidrWarnYn] = useState(false);
    

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkVmSubnetData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }
            
        }
    }, [props.clickedConfirmYn]);

    
    useEffect(() => {
        if(executeAddYn) {
            executeAddVmSubnet();
        }
    }, [executeAddYn]);

    function checkVmSubnetData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        
        setVmSubnetNameWarnYn(false);
        setCidrWarnYn(false);
        let message = "";
        let error = false;
        if(!vmSubnetName || !cidr) {
            message = t("MESSAGE_SUBNET_INFO_ENTER_ERROR_MESSAGE")
            if(!vmSubnetName) {
                setVmSubnetNameWarnYn(true);    
            }
            if(!cidr) {
                setCidrWarnYn(true);
            }
            error = true;
        }

        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function executeAddVmSubnet() {
        const addPackageData = {
            subnet: {
                subnet_name: vmSubnetName,
                subnet_description: vmSubnetDesc,
                cidr: cidr,
                dhcp_yn: dhcpYn,
                ip_version: ipVersion
            },
            network: {
                network_id:vmNetworkId
            }
        };
        if(allocatePools) {
            addPackageData['subnet']['allocated_ip_pools'] = allocatePools;
        }
        if(dnsNameServers) {
            addPackageData['subnet']['dns_nameservers'] = dnsNameServers;
        }
        if(hostRoutes) {
            addPackageData['subnet']['host_routes'] = hostRoutes;
        }
          
        if(gatewayYn === false) {
            addPackageData['subnet']['gateway_ip_address'] = null;
        } else {
            if(gatewayIpAddress) {
                addPackageData['subnet']['gateway_ip_address'] = gatewayIpAddress;
            }    
        }

        requests.post(PLATFORM_URL.VM_NETWORK + '/' + vmNetworkId + '/subnets', addPackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_SUBNET_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_SUBNET_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("VM_NETWORK_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SUBNET_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={2} 
                                width={570} height={36} 
                                value={vmSubnetName} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setVmSubnetName} 
                                warnYn={vmSubnetNameWarnYn} 
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea 
                                key={3} 
                                width={570} 
                                height={100} 
                                value={vmSubnetDesc} 
                                type={"text"} 
                                activeYn={true}
                                inputCb={setVmSubnetDesc} 
                                warnYn={false} 
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("CIDR")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={4} 
                                width={370} height={36} 
                                value={cidr} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setCidr} 
                                warnYn={vmCidrWarnYn} 
                                placeHolderText={t("0.0.0.0/0")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("IP_VERSION_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomRadioBtn 
                                id={"IpVersionType"} 
                                type={"IPv4"} 
                                size={18} 
                                checked={true} 
                                activeYn={false}
                                selectCb={(id, type) => {}}
                                label={"IPv4"}
                                labelStyle={labelStyle}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("GATEWAY_DEACTIVATE_TEXT")}
                            </Text>
                            <CustomSquareCheckBox 
                                id={"GatewayYn"}
                                key={8} 
                                checked={!gatewayYn}
                                label={t("INACTIVE_TEXT")}
                                setCheckBoxStatus={(e) => {setGatewayYn(!gatewayYn)}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("GATEWAY_IP_TEXT")}
                            </Text>
                            <CustomTextInput 
                                key={7} 
                                width={370} height={36} 
                                value={gatewayIpAddress} 
                                type={"text"} 
                                activeYn={gatewayYn} 
                                inputCb={setGatewayIpAddress} 
                                warnYn={false} 
                                placeHolderText={t("000.000.000.000")}
                            />
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("VM_SUBNET_NOT_USE_GATEWAY_MESSAGE")}
                        </Text>
                        <View style={style.rowDivContainer}></View>
                    </View>
                    <Text style={style.titleText}>{
                        t("DETAIL_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("USE_DHCP_TEXT")}
                            </Text>
                            <CustomSquareCheckBox 
                                id={"DhcpYn"}
                                key={9} 
                                checked={dhcpYn}
                                setCheckBoxStatus={(e) => {setDhcpYn(!dhcpYn)}}
                                label={t("USE_TEXT")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("ALLOCATE_POOLS_LIST")}
                            </Text>
                            <TextArea 
                                key={10} 
                                width={570} 
                                height={100} 
                                value={allocatePools} 
                                type={"text"} 
                                activeYn={true}
                                inputCb={setAllocatePools} 
                                warnYn={false} 
                                placeHolderText={t("VM_SUBNET_ALLOCATE_POOLS_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("DNS_NAMESERVERS_LIST")}
                            </Text>
                            <CustomTextInput 
                                key={11} 
                                width={570} height={36} 
                                value={dnsNameServers} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setDnsNameServers} 
                                warnYn={false} 
                                placeHolderText={t("VM_SUBNET_IP_LIST_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("HOST_ROUTES_LIST")}
                            </Text>
                            <CustomTextInput 
                                key={12} 
                                width={570} height={36} 
                                value={hostRoutes} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setHostRoutes} 
                                warnYn={false} 
                                placeHolderText={t("VM_SUBNET_IP_LIST_ENTER_MESSAGE")}
                            />
                        </View>
                    </View>
                </View> 
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}